import { createFileRoute, redirect, useRouter } from '@tanstack/react-router';
import { AdminDashboard } from '../components/admin/AdminDashboard';
import { Layout } from '../components/layout/Layout';

const AdminPage = () => {
  const router = useRouter();

  const handleBack = () => {
    router.navigate({ to: '/dashboard' });
  };

  return (
    <Layout pageTitle="Administration Center" showBackButton onBack={handleBack}>
      <div className="w-full mx-auto px-4 sm:px-6 lg:px-8 py-8 overflow-x-hidden">
        <AdminDashboard />
      </div>
    </Layout>
  );
};

export const Route = createFileRoute('/admin')({
  component: AdminPage,
  beforeLoad: ({ context }: any) => {
    // Redirect to login if not authenticated
    if (!context.auth?.isAuthenticated) {
      throw redirect({ to: '/' });
    }
    
    // Redirect to dashboard if not an administrator
    if (context.auth?.user?.role !== 'ADMINISTRATOR') {
      throw redirect({ to: '/dashboard' });
    }
  },
});
